module.exports = __webpack_public_path__ + "img/link01.fd4a4a1a.jpg";